import { useContext } from 'react';
import { makeStyles } from 'tss-react/mui';
import { meters2ScreenPixels } from './common/utils';
import { MapZoomContext } from './MapContext';
import type { CircleProps } from './interfaces';

const useStyles = makeStyles({ name: 'Circle' })((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[500],
    opacity: 0.2,
    borderStyle: 'dashed',
    borderWidth: '2px',
    borderColor: theme.palette.grey[50],
    borderRadius: '100%',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
}));

export const Circle: React.FC<CircleProps> = ({
  lat, lng, radius,
}) => {
  const { classes } = useStyles();

  const zoom = useContext(MapZoomContext);
  const { w: width, h: height } = meters2ScreenPixels(radius, { lat, lng }, zoom);

  return (
    <div
      className={classes.root}
      style={{
        width,
        height,
      }}
    />
  );
};

export default Circle;
